module.exports = __webpack_public_path__ + "static/media/bg.115212b7.jpg";